module.exports = __webpack_public_path__ + "img/kid-five.be7412da.svg";